import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHistory = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 6V9.33333H10M2 2V5.33333M2 5.33333H5.33333M2 5.33333L4 3.52779C5.06151 2.57771 6.46329 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C5.14455 14 2.75498 12.0053 2.14868 9.33333",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgHistory;
